export default __webpack_public_path__ + "static/media/surcos_2.ff65fb07.jpg";